// extracted by mini-css-extract-plugin
export default {"aside":"index_aside_zZI7a","ad":"index_ad_4XuOz"};